import gql from 'graphql-tag';

export const OnboardingManualTrialModalQuery = gql`
	query OnboardingManualTrialModalQuery {
		personalSpace: user(current: true) {
			id
			confluence {
				hasPersonalSpace
				space {
					id
					key
				}
			}
		}
		popularSpaces: popularFeed(first: 25) {
			nodes {
				content {
					id
					space {
						id
						key
						type
					}
				}
			}
		}
		starredSpace: spaces(favourite: true, first: 1, status: "current") {
			nodes {
				id
				key
			}
		}
		recentSpaces: recentSpaces {
			id
			key
		}
	}
`;
